import { render, staticRenderFns } from "./settingsheader.vue?vue&type=template&id=d53ddbe2&scoped=true&"
import script from "./settingsheader.vue?vue&type=script&lang=js&"
export * from "./settingsheader.vue?vue&type=script&lang=js&"
import style0 from "./settingsheader.vue?vue&type=style&index=0&id=d53ddbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53ddbe2",
  null
  
)

export default component.exports